import React, { Component } from 'react';
import axios from 'axios'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { server_url } from '../func/Comp';
import '../styles/project-list.scss'

const mapDispatchToProps = (dispatch) => {
    return {
        updateSizes: (x, y) => { dispatch(setSizes([x, y])) },
        setforcerender: (value) => { dispatch(setForceFlag(value)) },
        openCustomLoader: (value) => { dispatch(openCustomLoader(value)) }
    };
}
const mapStateToProps = state => {
    return {
        sizes: [state.width, state.height], customloader: state.customLoader
    };
}

class MainComp extends Component {
    constructor(props) {
        super(props)
        this.state = {
            projectList: []
        }
    }

    // FUNCTION CALLED THE FIRTS TIME THE COMPONENT LOADS - SETS DEFAULT SIZES
    componentDidMount() {
        const cus_id = this.props.match.params.customer
        this.getInitialData(cus_id);
    }

    // FUNCTION TO GET THE MENI DATA FROM JSON
    getInitialData(cus_id) {
        var that = this
        axios.post(`${server_url}/get_projects_by_userid/${cus_id}`).then(response => {
            if (response.status === 200) {
                const projectList = response.data.data?.result
                this.setState({ projectList })
            }
        })
    }

    clickLink(proj_id) {
        window.open(server_url + "/client/?project=" + proj_id, '_blank');
    }

    render() {
        let { projectList } = this.state

        return (
            <div id="project-list">
                {
                    projectList.map((proj) => <div key={proj.id} onClick={this.clickLink.bind(this, proj.id)} className='project-item' style={{ width: proj.thumb_sizes[0], height: proj.thumb_sizes[2] }}>
                        <div className='img-area' style={{ backgroundImage: `url('${server_url + proj.proj_img}')`, height: proj.thumb_sizes[1] }}></div>
                        <h6 style={{ fontSize: proj.thumb_sizes[3], padding: proj.thumb_sizes[4] }}>
                            {proj.slug ? proj.slug : proj.project_name} <label>&rarr;</label>
                        </h6>
                        {/* <div className='text-area' style={{ width: proj.thumb_sizes[0] }}>
                            {ReactHtmlParser(proj.description)}
                        </div> */}
                    </div>)
                }
            </div>)
    }
}

const Comp = connect(mapStateToProps, mapDispatchToProps)(MainComp);
export default withRouter(Comp);
